import { DatesRange } from '@utils/types/calendar';
import { getListingPriceRequest } from '@api/listings/estimateListingPrice';
import { useQuery } from 'react-query';

export function useGetListingPrice(props: {
  listingId: string;
  dateStart: DatesRange['from'];
  dateEnd: DatesRange['to'];
  paymentMethod?: Object;
  discountCode?: string;
  withPetFee?: boolean;
  guestyReservationID?: string;
  upsellAlternative?: string;
  bookingID?: string;
}) {
  const {
    listingId,
    dateStart,
    dateEnd,
    paymentMethod,
    discountCode,
    withPetFee,
    guestyReservationID,
    upsellAlternative,
    bookingID,
  } = props;
  return useQuery(
    [
      'getListingPrice',
      listingId,
      dateStart,
      dateEnd,
      paymentMethod,
      discountCode,
      withPetFee,
      upsellAlternative,
      bookingID,
    ],
    () =>
      getListingPriceRequest({
        listingId,
        dateStart,
        dateEnd,
        paymentMethod,
        discountCode,
        withPetFee,
        upsellAlternative,
        bookingID,
      }),
    {
      /**
       * if guestyReservationID is present, we don't need to use
       * estimateListingPrice endpoint. The source of truth is
       * /v2/booking_itinerary/ endpoint (the response of this endpoint
       * is passed from the previous itinerary page)
       */
      enabled: !!dateStart && !!dateEnd && !guestyReservationID,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );
}
